export default __webpack_public_path__ + "static/media/celestial_00.a2c10642.png";